// App.js
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import AppRoutes from "./routes/AppRoutes";
import { AuthProvider } from "./hooks/useAuth";
// import useAuth from "./hooks/useAuth";
import SessionProvider from "./hooks/SessionProvider";
// import { useSessionTracker } from "./hooks/useSessionTracker";
import "./App.css";

// function AppContent() {
//   const { logout } = useAuth();
//   useSessionTracker({ onIdleLogout: logout });
//   return <AppRoutes />;
// }

function App() {
  //   useEffect(() => {
  //   if (!user?.role?.id) return;

  //   const body = document.body;
  //   body.classList.remove("theme-admin", "theme-staff", "theme-student");

  //   switch (Number(user.role.id)) {
  //     case 1:
  //       body.classList.add("theme-admin");
  //       break;
  //     case 2:
  //     case 5:
  //       body.classList.add("theme-staff");
  //       break;
  //     case 3:
  //     case 4:
  //       body.classList.add("theme-student");
  //       break;
  //     default:
  //       break;
  //   }
  // }, [user]);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <SessionProvider>
            <AppRoutes />
            {/* <AppContent /> */}
          </SessionProvider>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
